import React from 'react';
import styled from 'styled-components';
import { useSwiper } from 'swiper/react';

const Button = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  cursor: pointer;
  margin-left: 40px;
  :hover {
    background: rgba(88, 255, 126, 1);
  }
`;

const SwiperButtonNext: React.FC = () => {
    const swiper = useSwiper();
    return (
        <Button onClick={() => swiper.slideNext()}>
            <img src="/assets/img/OfficeImages/ArrowForward.svg" alt="Next" />
        </Button>
    );
};

export default SwiperButtonNext;
